
import {Component, Vue, Watch} from 'vue-property-decorator';
import {ToolDocument} from '@/models/tobject.model';
import {fetchTools, getTObject} from '@/axios/repository/tobject.axios';
import AccessoryStoreListCard from "@/components/stead/store/accessories/AccessoryStoreListCard.vue";

@Component({
    components: {AccessoryStoreListCard}
  })
  export default class sbSelectToolDialog extends Vue {
    // Les props
    // @PropSync('show') private isVisible!: boolean

    // Les propriétés
    private isVisible: boolean = false
    private loading: boolean = false
    private loadtool: boolean = false
    private tools: ToolDocument[] = []

    // Les propriétés calculées
    private get prjid(): string | null {
      const prj = this.$store.state.current.Project
      return prj ? prj._id : null
    }

    // Les hooks
    public async mounted() {
      await this.onChangePrjid()
    }

    // Les méthodes surveillées
    @Watch('prjid')
    private async onChangePrjid() {
      if (this.prjid != null) {
        this.loading = true
        this.tools = await fetchTools({prjid: this.prjid})
        this.loading = false
      }
    }

    // Les méthodes d'instance
    private async onClick(tool: ToolDocument) {
      this.loadtool = true
      tool = await getTObject(tool._id)
      this.$emit('tool', tool)
      this.loadtool = false
      this.isVisible = false
    }

    private onClose() {
      this.isVisible = false
      this.$emit('cancel')
    }

    // Les méthodes statiques
  }
